var _defs, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPas4Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Object",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1122 1122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #323a89;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 46.85px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #30378b;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 258.61,
    y: 225.41,
    width: 568.45,
    height: 67.97
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 258.61,
    y: 383.53,
    width: 568.45,
    height: 67.97
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 258.61,
    y: 547.5,
    width: 568.45,
    height: 67.97
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 258.61,
    y: 711.48,
    width: 568.45,
    height: 67.97
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 141,
    y: 33,
    width: 790.61,
    height: 1060,
    rx: 3.83,
    ry: 3.83
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPas4Icon);
export default __webpack_public_path__ + "static/media/pas4Icon.61c67f16b01756106e9b39905fe2c11a.svg";
export { ForwardRef as ReactComponent };